export class ModalidadeCurso {
    id: number;    
    descricao: string;
}